"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledMessageList = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var StyledMessageList = exports.StyledMessageList = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  transition-property: padding-bottom, padding-top;\n  transition-duration: var(--transition-delay-5);\n  transition-timing-function: ease-out;\n  flex-direction: column-reverse;\n  padding-left: var(--spacing-2);\n  padding-right: var(--spacing-2);\n  padding-top:\n    ", ";\n  padding-bottom:\n    ", ";\n  overflow-y: scroll;\n  overflow-x: hidden;\n  scroll-behavior: 'smooth';\n  height: 100svh;\n  min-width: 100vw;\n  min-height: 100svh;\n\n  @media (min-width: 840px) {\n    min-width: unset;\n    min-height: unset;\n    padding-top: ", ";\n    padding-right:\n    ", ";\n    padding-bottom: 148px;\n    padding-left:\n      ", ";\n    height: 100%;\n  }\n"])), function (_ref) {
  var secondHidden = _ref.secondHidden;
  return secondHidden ? '90px' : '153px';
}, function (_ref2) {
  var predefinedHidden = _ref2.predefinedHidden;
  return predefinedHidden ? '101px' : '148px';
}, function (_ref3) {
  var isAdview = _ref3.isAdview;
  return isAdview ? '84px' : '113px';
}, function (_ref4) {
  var isAdview = _ref4.isAdview;
  return isAdview ? 'var(--spacing-2)' : 'var(--spacing-5)';
}, function (_ref5) {
  var isAdview = _ref5.isAdview;
  return isAdview ? 'var(--spacing-2)' : 'var(--spacing-5)';
});